import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { useAxios } from '../../../hooks/Axios';
import { useStore } from '../../../hooks/Store';
import { useConfiguration } from '../../../hooks/Configuration';
import { EMessageDirection, EMessageType, IOutcommingTextInput, useMessages } from '../../../hooks/Messages';
import { ConfigurationFeaturesFooterModeEnum } from '../../../api/models';

function Footer() {
    const [qestion, setQestion] = useState<string>('');
    const configuration = useConfiguration();
    const axios = useAxios();
    const { store, setStore } = useStore();
    const { push } = useMessages();

    const submitHandler = useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();

            if (!qestion || store.disableSendButton) return;

            push({
                direction: EMessageDirection.Outcomming,
                type: EMessageType.TextInput,
                payload: {
                    text: qestion
                } as IOutcommingTextInput
            });
            setQestion('');
        },
        [qestion, store.disableSendButton, push]
    );

    const changeHandler = useCallback(
        ({ currentTarget }: React.FormEvent<HTMLInputElement>) => {
            setQestion(currentTarget.value);
        },
        []
    );

    const renewHandler = useCallback(
        () => {
            setStore({
                ...store,
                disableFAQ: true,
                disableRenewButton: true,
                disableSendButton: true,
                disableTextInput: true
            });
            axios.get<undefined>('renew');
        },
        [axios, setStore, store]
    );

    const renewButton = (
        <button
            id='stx-new-session'
            style={{
                backgroundImage: configuration?.styles.btnRenewImage ? `url(${configuration?.mediaPath}${configuration?.styles.btnRenewImage})` : undefined,
                backgroundColor: configuration?.styles.btnRenewBgColor,
                color: configuration?.styles.btnRenewColor
            }}
            onClick={renewHandler}
            title={configuration?.texts.btnRenewTitle}
            disabled={store.disableRenewButton}>
            {
                configuration?.styles.btnRenewImage ?
                    <div> </div> :
                    <FontAwesomeIcon
                        icon={icon({ name: 'trash' })}
                        size='lg' />
            }
        </button>
    );

    const sendButton = (
        <button
            style={{
                backgroundImage: configuration?.styles.btnSendImage ? `url(${configuration?.mediaPath}${configuration?.styles.btnSendImage})` : undefined,
                backgroundColor: configuration?.styles.btnSendBgColor,
                color: configuration?.styles.btnSendColor
            }}
            type='submit'
            title={configuration?.texts.btnSendTitle}
            disabled={!qestion || store.disableSendButton}>
            {
                configuration?.styles.btnSendImage ?
                    <div> </div> :
                    <FontAwesomeIcon
                        icon={icon({ name: 'paper-plane' })}
                        size='lg' />
            }
        </button>
    );

    return (
        <div
            id='stx-footer'
            style={{
                backgroundColor: configuration?.styles.footerBgColor
            }}>
            {
                configuration?.features.footerMode === ConfigurationFeaturesFooterModeEnum.RIS &&
                renewButton
            }

            <form
                id='stx-chat-input'
                onSubmit={submitHandler}>
                <input
                    type='text'
                    placeholder={configuration?.texts.inputPlaceholder}
                    value={qestion}
                    onChange={changeHandler}
                    autoFocus
                    autoComplete='off'
                    disabled={store.disableTextInput} />
                {sendButton}
            </form>
            {
                configuration?.features.footerMode === ConfigurationFeaturesFooterModeEnum.ISR &&
                renewButton
            }
        </div>
    );
}

export default Footer;
